export default "__VITE_ASSET__CLujKbcj__"